// Module
var code = "<ui-view> <coaches-list></coaches-list> </ui-view> ";
// Exports
module.exports = code;